import { Box } from "@chakra-ui/react";
import React, { createContext, useContext, useEffect } from "react";
import { Link } from "react-router";
import "./index.css";
import useProfile from "../../hooks/data/useProfile";
import useReactiveQuery from "../../hooks/data/useReactiveQuery";
import useUserStore from "../../store/userStore";
import { shallow } from "zustand/shallow";

const UserContext = createContext();

/**
 *
 * @param {import("@chakra-ui/react").BoxProps & {user: import("./props").UserProps, preventFetch: boolean}} props
 * @returns
 */
export function UserProvider(props) {
  const { user, preventFetch, ...rest } = props;
  const { getProfile } = useProfile();
  const { get } = useReactiveQuery();
  const stateUser = useUserStore((state) => state.user, shallow);
  const profile = user.username ? get(["profiles", user.username]) : stateUser;

  const data = user.fullName ? user : profile;

  useEffect(() => {
    if (!user.fullName && (user.username || user.id) && !preventFetch) {
      getProfile({ uid: user.id, username: user.username });
    }
  }, [user]);

  return (
    <UserContext.Provider value={data ?? user}>
      <Box
        className={"user-container"}
        as={user.allowNavigate ? Link : Box}
        to={`/user/${user?.username}`}
        role="group"
        minH="max-content"
        minW="max-content"
        {...rest}
      >
        {data?.id && rest.children}
      </Box>
    </UserContext.Provider>
  );
}

/**
 *
 * @returns {import("./props").UserProps}
 */
export function useUserProvider() {
  const ctx = useContext(UserContext);
  if (ctx === undefined) {
    throw new Error("useStripe must be used within <StripeProvider>");
  }
  return ctx;
}
